'use strict';

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isClient = typeof window !== 'undefined';

var _require = require('@ali/app-link'),
    callApp = _require.callApp,
    BROWSER_TYPE = _require.BROWSER_TYPE;

var openWindow = require('../../utils/open_window');

var _require2 = require('./constants'),
    baseBlackList = _require2.baseBlackList;

var isBlackList = require('./is_black_list');

var _require3 = require('../download/call'),
    getDownloadUrl = _require3.getDownloadUrl;

var getQuery = require('../../utils/get_query');
var getFactParam = require('../../utils/get_fact_param');
var storage = isClient ? require('@ali/simple-storage') : {};
var uaBrowserName = isClient ? storage.getCookie('applink_browser_name') : '';

var _require4 = require('../../utils/index'),
    removeParam = _require4.removeParam;

var encodeQueryParameter = require('../../utils/encode_query');
isClient && __logCallSuccess();

function callOrDownload() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};


  if (isCalled(config)) {
    return;
  }

  // 复制config,避免数据玷污
  var tempConfig = (0, _assign2.default)({}, config, { isAuto: false });
  // 删掉残留的公参
  tempConfig = removeUcParams(tempConfig);
  // 添加query参数
  tempConfig = addQueryParam(tempConfig);
  // 给 __sd 和 uc_biz_str 再 encode 一次，避免特殊字符导致唤起 UC 之后变成搜索
  tempConfig.url = encodeQueryParameter('__sd', tempConfig.url);
  tempConfig.url = encodeQueryParameter('uc_biz_str', tempConfig.url);

  var _tempConfig = tempConfig,
      blackList = _tempConfig.blackList,
      downloadConfig = _tempConfig.downloadConfig,
      downloadUrl = _tempConfig.downloadUrl;


  if (!downloadConfig && !downloadUrl) {
    throw new Error('请配置downloadConfig或者downloadUrl');
  }
  // 通过下载配置获取到下载链接
  tempConfig.downloadUrl = downloadUrl || getDownloadUrl(downloadConfig);

  // 黑名单
  var finalBlackList = (Array.isArray(blackList) || []).concat(baseBlackList);

  log(config.logParams);

  if (isBlackList(finalBlackList)) {
    // 在黑名单中直接下载
    openWindow(tempConfig.downloadUrl);
  } else {
    callApp(tempConfig);
  }
}

function callRightNow() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};


  if (isCalled(config)) {
    return;
  }

  var blackList = config.blackList;
  // 黑名单

  var finalBlackList = (Array.isArray(blackList) || []).concat(baseBlackList);
  if (!isBlackList(finalBlackList)) {
    var tempConfig = (0, _assign2.default)({}, config, { isAuto: true, downloadUrl: null });
    // 删掉残留的公参
    tempConfig = removeUcParams(tempConfig);
    // 添加query参数
    tempConfig = addQueryParam(tempConfig);
    // 给 __sd 和 uc_biz_str 再 encode 一次，避免特殊字符导致唤起 UC 之后变成搜索
    tempConfig.url = encodeQueryParameter('__sd', tempConfig.url);
    tempConfig.url = encodeQueryParameter('uc_biz_str', tempConfig.url);
    // 不在黑名单才执行立即唤起
    callApp(tempConfig);
  }
}

function log() {
  var stats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var logger = require('@ali/log');
  // 标准日志
  logger.download(getFactParam(stats));
}

// 当前浏览器已经是需要唤起的浏览器类型
function isCalled(config) {
  return uaBrowserName === (config.appType || BROWSER_TYPE.UC_NEWS_INTL) || getQuery('isFromAppLink') === 'true';
}

function addQueryParam(tempConfig) {
  // 加上活动的特定渠道标识
  var entry = getQuery('entry') || '';
  var entry1 = entry.match('share') ? 'shareback' : 'browser';
  var __callT = Date.now();
  tempConfig.query = (0, _assign2.default)(tempConfig.query || {}, { isAuto: tempConfig.isAuto, entry1: entry1, entry2: 'activity', __callT: __callT });
  return tempConfig;
}

function removeUcParams(tempConfig) {
  var arr = ['ds', 'dn', 'fr', 'pf', 'bi', 've', 'ss', 'cp', 'gi', 'mi', 'bt', 'bm', 'ni', 'jb', 'la', 'up', 'ut', 'og', 'pi', 'nt', 'nw', 'ch'];
  // 如果不传入uri参数，则以当前的访问路径为准
  var targetUrl = tempConfig.url || window.location.href;
  arr.forEach(function (p) {
    targetUrl = removeParam(p, targetUrl);
  });
  tempConfig.url = targetUrl;
  return tempConfig;
}

function __logCallSuccess() {
  setTimeout(function () {
    var isFromAppLink = getQuery('isFromAppLink');
    if (isFromAppLink === 'true') {
      var __callT = getQuery('__callT');
      var isAuto = getQuery('isAuto');
      var appType = getQuery('appType');
      var entry = getQuery('entry');
      var pageName = window.location.pathname.split('/').pop();
      var now = Date.now();
      if (now - parseInt(__callT) < 1000 * 10) {
        require('@ali/log').logEvent('applink', 'callSuccess', { isFromAppLink: true, isAuto: isAuto, appType: appType, entry: entry });
        require('@ali/log').logVisit(pageName, { isFromAppLink: true, isAuto: isAuto, appType: appType, entry: entry });
      }
    }
  }, 2000);
}

module.exports = {
  callOrDownload: callOrDownload,
  callRightNow: callRightNow,
  appType: BROWSER_TYPE
};